export enum NEWS_CARD_SIZE {
    SMALL = 'small',
    BIG = 'large',
};

export enum Locale {
    English = 'en',
    Belarusian = 'be',
    Russian = 'ru',
}